import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit, output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, map, Observable } from 'rxjs';

import { LocalStorageService, StorageKey } from '@blaze-shared/platform-data-access';
import { ButtonComponent } from '@blaze-shared/shared-ui';

import { ApiBuilderStore } from '../+state/api-builder.store';
import { ApiActionCardComponent } from '../api-action-card/api-action-card.component';
import { ApiBuilderAction, ApiBuilderCommonConfig } from '../api-builder.model';
import { ApiGeneralCardComponent } from '../api-general-card/api-general-card.component';

@UntilDestroy()
@Component({
  selector: 'blaze-api-builder',
  imports: [ApiActionCardComponent, ApiGeneralCardComponent, AsyncPipe, ButtonComponent],
  templateUrl: './api-builder.component.html',
  styleUrls: ['./api-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiBuilderComponent implements OnInit {
  private readonly apiBuilderStore = inject(ApiBuilderStore);
  readonly localStorageService = inject(LocalStorageService);

  apiDataChanged = output<{ settings: ApiBuilderCommonConfig; actions: ApiBuilderAction[] }>();

  @Input() showValidation = false;

  actions: ApiBuilderAction[] = [];
  actions$: Observable<ApiBuilderAction[]>;
  settings$: Observable<ApiBuilderCommonConfig>;
  actionCount$: Observable<number>;
  canDeleteAction$: Observable<boolean>;
  accountId = '';

  constructor() {
    const localStorageService = this.localStorageService;

    this.settings$ = this.apiBuilderStore.common$;
    this.actions$ = this.apiBuilderStore.actions$;
    this.canDeleteAction$ = this.actions$.pipe(map((actions) => actions.length > 1));
    this.actionCount$ = this.actions$.pipe(map((actions) => actions.length));
    this.accountId = localStorageService.get(StorageKey.AccountId) || '';
  }

  ngOnInit(): void {
    combineLatest([this.settings$, this.actions$])
      .pipe(untilDestroyed(this))
      .subscribe(([settings, actions]) => {
        this.apiDataChanged.emit({ settings, actions });
      });
  }

  addNewAction(): void {
    this.apiBuilderStore.addAction();
  }

  updateAction(action: ApiBuilderAction): void {
    this.apiBuilderStore.updateAction(action);
  }
}
